<template>
  <SbMenu
    :model-value="isMenuOpen"
    class="sb-pagination__overflow"
    @close="closeMenu"
  >
    <SbMenuButton
      ref="overflowButton"
      label="…"
      hidden-label="Show more pages"
      appearance="clear"
      variant="default"
      size="small"
      @click="toggleMenu"
    />
    <SbMenuList
      placement="bottom-start"
      :reference="overflowButton"
      class="sb-pagination__overflow-list"
    >
      <SbMenuItem v-for="page in pages" :key="page" @click="selectPage(page)">
        <a class="sb-pagination__overflow-item">{{ page }}</a>
      </SbMenuItem>
    </SbMenuList>
  </SbMenu>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { SbMenu, SbMenuItem, SbMenuButton, SbMenuList } from '../../Menu'

defineProps<{
  pages: number[]
}>()

const emit = defineEmits<{
  (e: 'select', page: number): void
}>()

const overflowButton = ref<HTMLButtonElement | undefined>(undefined)
const isMenuOpen = ref(false)

function selectPage(page: number) {
  emit('select', page)
  closeMenu()
}
function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value
}
function closeMenu() {
  isMenuOpen.value = false
}
</script>
